export const TOAST = {
  UPDATE_PROFILE_SUCCESS: 'Update successful',
  UPDATE_PROFILE_FAILED: 'UPDATE_PROFILE_FAILED',
};
